module.exports = __webpack_public_path__ + "img/black_king.d7cb8763.png";